var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hero-page"},[_c('div',{staticClass:"hero-container"},[_c('div',{staticClass:"column"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.description))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }